import { render, staticRenderFns } from "./printedVoucher.vue?vue&type=template&id=955f23cc&"
import script from "./printedVoucher.vue?vue&type=script&lang=js&"
export * from "./printedVoucher.vue?vue&type=script&lang=js&"
import style0 from "./printedVoucher.vue?vue&type=style&index=0&id=955f23cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports